import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card as MuiCard } from '@mui/material';
import { forwardRef } from 'react';
import { styled } from '../../../utils';
import { Icon } from '../../Icon';
import { Typography } from '../../Typography';
export const Card = forwardRef(function CardComponent(props, ref) {
    const { error, helperText, dataName, ...otherProps } = props;
    return (_jsxs(RootStyled, { "data-name": dataName, ref: ref, children: [_jsx(CardStyled, { error: error, ...otherProps }), helperText && (_jsx(HelperTextStyled, { children: error && (_jsxs(HelperTypographyStyled, { color: "error", children: [_jsx(Icon, { variant: "alert-sign" }), helperText] })) }))] }));
});
function variantStyle(color, theme) {
    switch (color) {
        case 'primary':
            return {
                backgroundColor: theme.palette.primary['dark'],
                color: theme.palette.secondary.dark,
            };
        case 'secondary':
            return {
                backgroundColor: theme.palette.secondary['main'],
                color: theme.palette.secondary.dark,
            };
        default:
            return {
                backgroundColor: theme.palette.primary.contrastText,
                boxShadow: 'none',
                border: `1px solid ${theme.palette.groupPrimary.lightDove}`,
            };
    }
}
// TODO: Dont ask! If the parent is a grid the children of CardContent behavious different e.g. responsive table doesnt work
const RootStyled = styled('div')({
    display: 'grid',
});
const CardStyled = styled(MuiCard, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error, color }) => ({
    ...variantStyle(color, theme),
    ...(error && {
        border: `1px solid ${theme.palette.error.main}`,
    }),
}));
const HelperTextStyled = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(2),
}));
const HelperTypographyStyled = styled(Typography)(() => ({
    display: 'flex',
}));
